import React from 'react';
import { useMessageContext } from 'stream-chat-react';
import type { StreamChatType } from '../types';
import { SessionManager } from '../../services/SessionManager/SessionManager';
import './ReceivedMessageTimestamp.scss';

/**
 * ReceivedMessageTimestamp Component
 * 
 * Displays timestamp for received messages (messages not sent by the current user).
 * Positioned at the bottom-right of the message bubble, similar to WhatsApp.
 */
export const ReceivedMessageTimestamp: React.FC = () => {
  const { message } = useMessageContext<StreamChatType>();

  // Only show timestamp for messages NOT sent by the current user
  const isMyMessage = message.user?.id === SessionManager.shared.buyer?.id;
  
  if (isMyMessage || message.type === 'error' || message.status === 'failed') {
    return null;
  }

  // Format timestamp (e.g., "11:27 PM")
  const getFormattedTime = () => {
    if (!message.created_at) return '';
    
    const date = new Date(message.created_at);
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  return (
    <div className="received-message-timestamp">
      <span className="timestamp-text">{getFormattedTime()}</span>
    </div>
  );
};

